import { customAgencyQuestions } from './capabilities';
import { complianceStatuses } from '../constants/agency';

export const hasCompliance = status =>
  status === complianceStatuses.PENDING_TO_REVIEW ||
  status === complianceStatuses.VERIFIED_INTERNALLY;

export const isNonVerified = status =>
  status === complianceStatuses.NON_VERIFIED;

export const isVerifiedExternally = status =>
  status === complianceStatuses.VERIFIED_EXTERNALLY;

export const isVerified = status =>
  status === complianceStatuses.VERIFIED_INTERNALLY ||
  status === complianceStatuses.VERIFIED_EXTERNALLY;

export const hasQuestion = questionKey =>
  customAgencyQuestions.includes(questionKey);
